var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1492_14383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48032 4.69409C1.53771 5.92048 0.826945 7.334 0.413086 8.86958H6.6558L2.48032 4.69409Z",
    fill: "#0057E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5864 8.86953C23.1725 7.334 22.4617 5.92048 21.5191 4.69409L17.3438 8.86953H23.5864Z",
    fill: "#0057E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.413086 15.1305C0.826992 16.666 1.53776 18.0795 2.48032 19.3059L6.65566 15.1305H0.413086Z",
    fill: "#0057E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3053 2.48061C18.0789 1.538 16.6655 0.827236 15.1299 0.41333V6.656L19.3053 2.48061Z",
    fill: "#0057E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69434 21.5192C5.92073 22.4618 7.33424 23.1726 8.86977 23.5865V17.3439L4.69434 21.5192Z",
    fill: "#0057E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86973 0.41333C7.3342 0.827236 5.92068 1.538 4.69434 2.48056L8.86973 6.65595V0.41333Z",
    fill: "#0057E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1299 23.5865C16.6654 23.1726 18.0789 22.4618 19.3053 21.5193L15.1299 17.3439V23.5865Z",
    fill: "#0057E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3438 15.1305L21.5191 19.3059C22.4617 18.0796 23.1725 16.666 23.5864 15.1305H17.3438Z",
    fill: "#0057E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1309 15.1305L20.4857 20.4854C20.732 20.2392 20.9669 19.9818 21.191 19.715L16.6066 15.1305H15.1309V15.1305Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86951 15.1305H8.86941L3.51465 20.4853C3.76084 20.7315 4.01823 20.9665 4.28504 21.1906L8.86951 16.6061V15.1305Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86976 8.8696V8.86951L3.51495 3.51465C3.26866 3.76084 3.03373 4.01823 2.80957 4.28504L7.39409 8.86955L8.86976 8.8696Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1309 8.86968L20.4857 3.51478C20.2395 3.2685 19.9821 3.03356 19.7153 2.80945L15.1309 7.39396V8.86968Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1492_14383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlEn);
export default __webpack_public_path__ + "static/media/fl_en.cd010aefc2108532debd8605e5c407fc.svg";
export { ForwardRef as ReactComponent };